import { BaseRestDataProvider } from './BaseRestDataProvider';
import { BinaryFile } from '../models/BinaryFile';

export class BinaryFileRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/binary-files');
  }

  getAll(): Promise<BinaryFile[]> {
    return this.get<BinaryFile[]>(``);
  }

  getById(id: string): Promise<BinaryFile> {
    return this.get<BinaryFile>(`/${id}`);
  }

  getByParentId(parentRecordId: string): Promise<BinaryFile[]> {
    return this.get<BinaryFile[]>(`/parent/${parentRecordId}`);
  }

  async upload(file: File, parentRecordId?: string): Promise<BinaryFile> {
    const formData = new FormData();
    formData.append('file', file);
    if (parentRecordId) formData.append('parentRecordId', parentRecordId);

    const token = BaseRestDataProvider.getToken();
    const response = await fetch(`${this.baseUrl}`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  download(id: string): Promise<Blob> {
    return this.getBlob(`/${id}/download`);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { BinaryFile };
